
import { Component, Prop, Vue } from "vue-property-decorator";
import QrCodeScannerWrapper from "@/components/qrcode/QrCodeScannerWrapper.vue";
import { TranslateResult } from "vue-i18n";
import { Getter } from "vuex-class";
import { CONTEXT_TYPES, IContext } from "@/store/modules/context";
import { ROWS_PER_PAGE } from "@/utils/constants";
import { KEY_STATUS } from "@/utils/keyStatus";

declare const Buffer;

@Component({
    components: {
        QrCodeScannerWrapper,
    },
})
export default class QrCodeReader extends Vue {
    @Prop({default: null})
    public location: any;

    @Prop({default: ""})
    public warningMessage?: TranslateResult;

    @Prop({default: () => []})
    public subObjects: any[];

    @Prop({default: false})
    public displayQrCodeReaderModal: boolean;

    @Prop({default: false})
    public loadingQrCodeStreamer: boolean;

    @Prop({default: ""})
    public keyPicture: string;

    @Prop({default: ""})
    public keyDescription: string;

    @Prop({default: ""})
    public qrCodeError: string;

    @Prop({default: ""})
    public action: string;

    @Prop({default: true})
    public hasForceInput: boolean;

    @Prop({default: false})
    public keyGroup: boolean;

    @Prop({default: ""})
    public keyGroupName: string;

    @Prop({default: null})
    public currentKey: any;

    @Prop({default: null})
    public targetUser: any;

    @Getter private context: IContext|null;
    @Getter private isMobile: boolean;

    private moveAllSubObjects: boolean = true;
    private isLoadingSubObjects: boolean = false;
    private subKeys: any[] = [];
    private headers = [{text : "Liste des sous-objects avec le même status", value : "name"}];
    private ROWS_PER_PAGE = ROWS_PER_PAGE;

    get subObjectsWithSameStatus(): any[] {
      if (this.subObjects.length > 0) { return this.subObjects; }
      if (this.subKeys.length > 0) { return this.subKeys; }
      return [];
    }

    get displayMoveAllSubObjects(): boolean {
        return this.subObjectsWithSameStatus?.length > 0 && this.context?.type !== CONTEXT_TYPES.LOCATION;
    }

    get keyReservedLocation(): any {
        return this.currentKey?.ReservedLocations?.[0];
    }

    private onDecode(result: string) {
        if (result) {
            this.$nextTick().then(() => {
                this.$emit("read-qr-code", {
                    token: result,
                    moveAllSubObjects: this.moveAllSubObjects,
                });
            });
        }
    }

    private async getSubObjects(): Promise<void> {
        this.isLoadingSubObjects = true;
        await this.$store.dispatch("keys/getSubKeys", {
          id: this.currentKey.id,
        }).then((res) => {
            if (this.action === "DROP") {
                const getReservedBoxId = (key) => key.ReservedLocations[0].boxId;
                this.subKeys = res.subKeys.filter((ck: any) => {
                    let sameHolder: boolean;
                    let sameReservedBox: boolean|undefined;
                    try {
                        sameHolder = ck.KeyHolding[0].User.id === this.currentKey.KeyHolding[0].User.id;
                    } catch (err) {
                        sameHolder = false;
                    }
                    if (this.currentKey.ReservedLocations[0] && ck.ReservedLocations?.[0]) {
                        try {
                            sameReservedBox = getReservedBoxId(ck) === getReservedBoxId(this.currentKey);
                        } catch (err) {
                            sameReservedBox = false;
                        }
                    }
                    return (this.currentKey.status === ck.status)
                        && (sameReservedBox || sameReservedBox === undefined)
                        && (sameHolder || ck.status === KEY_STATUS.IDLE);
                });
            } else {
                const getCurrentBoxId = (key) => key.KeyLocation?.[0]?.Location?.Box?.id;
                this.subKeys = res.subKeys.filter((ck: any) => {
                    let sameLocation: boolean;
                    try {
                        sameLocation = getCurrentBoxId(this.currentKey) === getCurrentBoxId(ck);
                    } catch (err) {
                        sameLocation = false;
                    }
                    return (this.currentKey.status === ck.status)
                        && (sameLocation || ck.status === KEY_STATUS.IDLE);
                });
            }
        }).finally(() => {
            this.isLoadingSubObjects = false;
            if (!this.subKeys?.length) {
                this.moveAllSubObjects = false;
            }
        });
    }

    private mounted() {
        if (this.subObjects.length === 0 && this.currentKey?.id && this.context?.type !== CONTEXT_TYPES.LOCATION) {
            this.getSubObjects();
        }
    }
}
